<div class="page-container gap-24">
  <app-table-header-navigation
    [slides]="cardSlides"
    [isLoading]="loadingSeminars"
    (cardClicked)="onCardClicked($event)"></app-table-header-navigation>

  <div class="seminar-table">
    <app-custom-table
      titleMultipleResults="Seminare"
      titleSingleResult="Seminar"
      titleResultSuffix="verfügbar"
      [dataSource$]="dataSource$"
      [columns]="columns"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageSize]="50"
      [fuzzySearch]="true"
      [filters]="filters"
      noDataIcon="fa-book-copy"
      noDataMessage="Es gibt derzeit keine Kurse."
      noSearchResultsIcon="fa-book-copy"
      noSearchResultsMessage="Es gibt keine Kurse, die mit deinen Suchkriterien übereinstimmen."
      [tableHeaderButton]="tableHeaderButton"
      [dataSource$]="dataSource$"
      [isLoading]="loadingSeminars"></app-custom-table>
  </div>
</div>
